/**
 * Snackbar-friendly message from API error responses.
 * @param {unknown} err axios error or string
 * @returns {string}
 */
export function whatsappErrorMessage(err) {
  if (!err) {
    return 'Unknown error';
  }
  if (typeof err === 'string') {
    return err;
  }
  const data = err.response && err.response.data;
  if (typeof data === 'string' && data.length) {
    return data;
  }
  if (data && typeof data === 'object') {
    if (data.code) {
      if (data.code === 'meta_error' && data.meta) {
        const parts = [data.code];
        if (data.meta.code != null) {
          parts.push(String(data.meta.code));
        }
        if (data.meta.error_subcode != null) {
          parts.push(String(data.meta.error_subcode));
        }
        return parts.join(' · ');
      }
      return String(data.code);
    }
    if (data.message) {
      if (typeof data.message === 'string') {
        return data.message;
      }
      return JSON.stringify(data.message);
    }
    if (data.is_on_biz_app === false) {
      return '409 · coexistence requires WhatsApp Business app';
    }
  }
  if (err.message) {
    return err.message;
  }
  return 'Unknown error';
}

export default whatsappErrorMessage;
